<div class="container-fluid py-3">
    <!-- Header -->
    <div class="d-flex align-items-center mb-3">
        <button class="btn btn-outline-secondary btn-sm me-3" (click)="goBack()">
            <i class="bi bi-arrow-left me-1"></i>{{ 'General.back' | translate }}
        </button>
        <h4 class="mb-0">
            <i class="bi bi-journal-text text-info me-2"></i>
            {{ 'EPortalApiLog.title' | translate }}
        </h4>
    </div>

    <!-- Filters -->
    <div class="card mb-3">
        <div class="card-body py-2">
            <div class="row g-2 align-items-end">
                <div class="col-md-2">
                    <label class="form-label small mb-1">{{ 'EPortalApiLog.fromDate' | translate }}</label>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
                </div>
                <div class="col-md-2">
                    <label class="form-label small mb-1">{{ 'EPortalApiLog.toDate' | translate }}</label>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
                </div>
                <div class="col-md-2">
                    <label class="form-label small mb-1">{{ 'EPortalApiLog.level' | translate }}</label>
                    <select class="form-select form-select-sm" [(ngModel)]="selectedLevel">
                        <option value="">{{ 'EPortalApiLog.allLevels' | translate }}</option>
                        <option *ngFor="let lvl of levels" [value]="lvl">{{ lvl }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label class="form-label small mb-1">{{ 'EPortalApiLog.domain' | translate }}</label>
                    <input type="text" class="form-control form-control-sm"
                           [placeholder]="'EPortalApiLog.domainPlaceholder' | translate"
                           [(ngModel)]="selectedDomain"
                           (keyup.enter)="onSearch()" />
                </div>
                <div class="col-md-2">
                    <label class="form-label small mb-1">{{ 'EPortalApiLog.searchText' | translate }}</label>
                    <input type="text" class="form-control form-control-sm"
                           [placeholder]="'EPortalApiLog.searchPlaceholder' | translate"
                           [(ngModel)]="searchText"
                           (keyup.enter)="onSearch()" />
                </div>
                <div class="col-md-2 d-flex gap-1 align-items-end">
                    <button class="btn btn-primary btn-sm" (click)="onSearch()">
                        <i class="bi bi-search me-1"></i>{{ 'EPortalApiLog.search' | translate }}
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">
                        <i class="bi bi-arrow-counterclockwise me-1"></i>{{ 'EPortalApiLog.reset' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && items.length === 0" class="text-center py-4 text-muted">
        <i class="bi bi-journal-text fs-1 d-block mb-2"></i>
        {{ 'EPortalApiLog.noResults' | translate }}
    </div>

    <!-- Results -->
    <div *ngIf="!loading && items.length > 0">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <small class="text-muted">
                {{ totalCount }} {{ 'EPortalApiLog.entries' | translate }}
            </small>
            <div class="d-flex align-items-center gap-2">
                <small class="text-muted">{{ 'EPortalApiLog.pageSize' | translate }}:</small>
                <select class="form-select form-select-sm" style="width: auto;"
                        [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-sm table-hover log-table">
                <thead>
                    <tr>
                        <th style="width: 160px;">{{ 'EPortalApiLog.timestamp' | translate }}</th>
                        <th style="width: 90px;">{{ 'EPortalApiLog.level' | translate }}</th>
                        <th style="width: 140px;">{{ 'EPortalApiLog.domain' | translate }}</th>
                        <th style="width: 120px;">{{ 'EPortalApiLog.user' | translate }}</th>
                        <th>{{ 'EPortalApiLog.message' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of items">
                        <tr class="log-row cursor-pointer" [class.log-row-expanded]="expandedRow === item.id"
                            (click)="toggleDetail(item)">
                            <td class="text-nowrap">{{ formatTimestamp(item.timeStamp) }}</td>
                            <td>
                                <span class="badge" [ngClass]="getLevelBadgeClass(item.level)">
                                    {{ item.level }}
                                </span>
                            </td>
                            <td class="text-truncate" style="max-width: 140px;">{{ item.tenantDomain || '-' }}</td>
                            <td class="text-truncate" style="max-width: 120px;">{{ item.tenantUser || '-' }}</td>
                            <td class="text-truncate" style="max-width: 400px;">{{ item.message }}</td>
                        </tr>
                        <tr *ngIf="expandedRow === item.id" class="detail-row">
                            <td colspan="5">
                                <div class="detail-panel p-3" *ngIf="loadingDetail">
                                    <div class="spinner-border spinner-border-sm text-primary spin" role="status"></div>
                                </div>
                                <div class="detail-panel p-3" *ngIf="!loadingDetail && selectedEntry">
                                    <div class="detail-section">
                                        <div class="detail-label">{{ 'EPortalApiLog.message' | translate }}</div>
                                        <pre class="detail-pre detail-pre-muted">{{ selectedEntry.message }}</pre>
                                    </div>
                                    <div class="detail-section" *ngIf="selectedEntry.messageTemplate">
                                        <div class="detail-label">{{ 'EPortalApiLog.messageTemplate' | translate }}</div>
                                        <pre class="detail-pre detail-pre-muted">{{ selectedEntry.messageTemplate }}</pre>
                                    </div>
                                    <div class="detail-section" *ngIf="selectedEntry.exception">
                                        <div class="detail-label">{{ 'EPortalApiLog.exception' | translate }}</div>
                                        <pre class="detail-pre detail-pre-danger">{{ selectedEntry.exception }}</pre>
                                    </div>
                                    <div class="detail-section" *ngIf="selectedEntry.properties">
                                        <div class="detail-label">{{ 'EPortalApiLog.properties' | translate }}</div>
                                        <pre class="detail-pre detail-pre-xml">{{ formatPropertiesXml(selectedEntry.properties) }}</pre>
                                    </div>
                                    <div class="detail-section" *ngIf="selectedEntry.logEvent">
                                        <div class="detail-label">{{ 'EPortalApiLog.logEvent' | translate }}</div>
                                        <pre class="detail-pre detail-pre-json">{{ formatLogEventJson(selectedEntry.logEvent) }}</pre>
                                    </div>
                                    <div class="detail-section" *ngIf="selectedEntry.tenantDomain || selectedEntry.tenantUser || selectedEntry.tenantUserId">
                                        <div class="detail-label">{{ 'EPortalApiLog.tenantInfo' | translate }}</div>
                                        <div class="d-flex gap-3 flex-wrap">
                                            <small *ngIf="selectedEntry.tenantDomain"><strong>{{ 'EPortalApiLog.domain' | translate }}:</strong> {{ selectedEntry.tenantDomain }}</small>
                                            <small *ngIf="selectedEntry.tenantUser"><strong>{{ 'EPortalApiLog.user' | translate }}:</strong> {{ selectedEntry.tenantUser }}</small>
                                            <small *ngIf="selectedEntry.tenantUserId"><strong>{{ 'EPortalApiLog.userId' | translate }}:</strong> {{ selectedEntry.tenantUserId }}</small>
                                        </div>
                                    </div>
                                    <div class="detail-meta mt-2 d-flex justify-content-between align-items-center">
                                        <small class="text-muted">ID: {{ selectedEntry.id }}</small>
                                        <div class="d-flex gap-2">
                                            <button class="btn btn-sm btn-outline-primary" (click)="copyDebugPrompt(selectedEntry)" [title]="'EPortalApiLog.generatePromptTooltip' | translate">
                                                <i class="bi bi-stars me-1" aria-hidden="true"></i>{{ 'EPortalApiLog.generatePrompt' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                    <!-- Prompt preview -->
                                    <div *ngIf="generatedPrompt && expandedRow === selectedEntry.id" class="detail-section mt-2">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <h6 class="detail-label mb-0">
                                                <i class="bi bi-stars me-1"></i>{{ 'EPortalApiLog.promptReady' | translate }}
                                            </h6>
                                            <button class="btn btn-sm btn-outline-secondary" (click)="generatedPrompt = null">
                                                <i class="bi bi-x-lg" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <pre class="detail-pre detail-pre-prompt">{{ generatedPrompt }}</pre>
                                        <small class="text-success"><i class="bi bi-check-circle me-1"></i>{{ 'EPortalApiLog.promptCopied' | translate }}</small>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <nav *ngIf="totalPages > 1" class="d-flex justify-content-center mt-2">
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="pageNumber <= 1">
                    <a class="page-link" (click)="onPageChange(pageNumber - 1)">
                        <i class="bi bi-chevron-left"></i>
                    </a>
                </li>
                <li class="page-item disabled">
                    <span class="page-link">{{ pageNumber }} / {{ totalPages }}</span>
                </li>
                <li class="page-item" [class.disabled]="pageNumber >= totalPages">
                    <a class="page-link" (click)="onPageChange(pageNumber + 1)">
                        <i class="bi bi-chevron-right"></i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</div>
